// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + "sentry" + "." + "51d1515cb1cf92bbcae9" + ".js";
};